<div class="header">
  <div class="logo-header">
    <div class="logo-main">
      <img src="../../assets/images/muniLogo.png" alt="SFMTA" />
    </div>
    <div class="site-name">
      Nearby Stops / paradas cercanas  / 附近的車站 / Malapit na hintuan
    </div>
  </div>
  <div class="web-name">
    SFMTA.com
  </div>
</div>

<div appMapListeners 
(resize)="mapWidth()"
(mousewheel)="parentMousewheel()"
(mouseup)="parentMousewheel()" 
class="map match-parent" id="map"></div>

<div #nearByStopsPredictionsNbIq>
  <div *ngIf="bubblesNbIq">

    <div *ngFor="let route of routeKeysNbIq; let i = index">
      <div *ngIf="i === 0" class="operatorHeader">
        {{route.stop.name}}  <span class="minNormal">{{' #' + route.stop.code}}</span>
      </div>
      <div class="bubble-container">
        <div class="bubbles_one" style="width:45px">
          <div class="circles" [ngStyle]="{'background-color': '#' + route.route.color}"  [ngClass]="{'circles_xs_font': (route.route.id).length > 2}">
            <div>{{route.route.id}}</div>
          </div>
        </div>
        <span *ngIf="route.values.length > 0">
          <div class="bubbles_second">{{route.values[0].direction.name}}</div>
          <div class="bubbles_last">
              <span *ngIf="route.values.length === 1">
                  {{route.values[0].minutes}} <span class="minNormal">min</span>
              </span>
              <span *ngIf="route.values.length > 1">
                  {{route.values[0].minutes}}, {{route.values[1].minutes}} <span class="minNormal">min</span>
              </span>
          </div>
        </span>

      </div>

    </div>

    <div *ngIf ="routeKeysNoDataCN">
      <div *ngFor="let route of routeKeysNoDataNbIq; let i = index">
        <div *ngIf="i === 0" class="operatorHeader">
          {{route.short_name }} <span class="minNormal">{{' #' + route.stop_code}}</span>
        </div>
        <div class="bubble-container" *ngIf="i === 0">
            <div class="bubbles_second" style="width: 420px;"> {{route.stop_code}}<span class="offline_nodata">Offline! no information available</span></div>
            <div class="bubbles_last" style="text-align: center;">-- --</div>
        </div>
      </div>
    </div>
    <div class="bubble-container" *ngIf="routeKeysNoDataFail">
      <div *ngFor="let noPrediction of routeKeysNbIq">
        <div class="bubbles_second" style="width: 420px;"> {{noPrediction.stopCode}}<span class="offline_nodata">Offline! no information available</span></div>
        <div class="bubbles_last" style="text-align: center;">-- --</div>
      </div>
    </div>

  </div>
</div> 

<div #nearByStopsPredictions  *ngIf="bubbles">
    <div *ngFor="let route of routeKeys; let i = index">
      <!-- <span *ngIf="routeKeys.length != 1 && route.length === 1">
        <div *ngIf="i === 0" class="operatorHeader">
          {{route[0].operatorName}} - {{route[0].MonitoredCall.StopPointName}}
        </div>
      </span>

      <span *ngIf="routeKeys.length === 1 && route.length === 1" >
        <div *ngIf="i === 0" class="operatorHeader">
        {{route[0].operatorName}} - {{route[0].MonitoredCall.StopPointName}}
        </div>
      </span> -->   
      <span *ngIf="route.length > 0">
        <div *ngIf="i === 0" class="operatorHeader"> {{route[0].MonitoredCall.StopPointName }} <span class="minNormal">{{' #' + route[0].MonitoredCall.StopPointRef}}</span>
        </div>
      </span>
      <div class="bubble-container">
        <span *ngIf="routeKeys.length != 1 && route.length === 1">
          <div class="bubbles_one" style="width:45px">
            <div class="circles"  [ngClass]="{'circles_xs_font': (route[0].LineRef).length > 2}">
              <div>{{route[0].LineRef}}</div>
            </div>
          </div>
          <div class="bubbles_second" *ngIf="route.MonitoredCall.DestinationDisplay != null">{{route[0].MonitoredCall.DestinationDisplay}}</div>
          <div class="bubbles_last" *ngIf="route.MonitoredCall.ExpectedArrivalTime != null">
              {{route[0].MonitoredCall.ExpectedArrivalTime}} <span class="minNormal">min</span>
          </div>
        </span>

        <span *ngIf="routeKeys.length === 1 && route.length === 1" >
          <div class="bubbles_one"  style="width:45px">
            <div class="circles"  [ngClass]="{'circles_xs_font': (route[0].LineRef).length > 2}">
              <div>{{route[0].LineRef}}</div>
            </div>
          </div>
          <div class="bubbles_second">{{route[0].MonitoredCall.DestinationDisplay}}</div>
          <div class="bubbles_last" *ngIf="route.MonitoredCall.ExpectedArrivalTime != null">
              {{route[0].MonitoredCall.ExpectedArrivalTime}} <span class="minNormal">min</span>
          </div>
        </span>

        
        <span *ngIf="route.length > 1">
          <div class="bubbles_one"  style="width:45px">
            <div class="circles"  [ngClass]="{'circles_xs_font': (route[0].LineRef).length > 2}">
              <div>{{route[0].LineRef}}</div>
            </div>
          </div>
          <div class="bubbles_second">{{route[0].MonitoredCall.DestinationDisplay}}</div>
          <div class="bubbles_last">
            <!-- <span *ngIf="route.length === 1">
              <span *ngIf="route[0].MonitoredCall.ExpectedArrivalTime === null">
                
              </span>
              <span *ngIf="route[0].MonitoredCall.ExpectedArrivalTime != null">
                {{route[0].MonitoredCall.ExpectedArrivalTime}} min
              </span>
            
            </span> -->
            <span *ngIf="route.length > 1">
              <span *ngIf="route[0].MonitoredCall.ExpectedArrivalTime != null">{{route[0].MonitoredCall.ExpectedArrivalTime}}</span>
              <span *ngIf="route[0].MonitoredCall.ExpectedArrivalTime != null && route[1].MonitoredCall.ExpectedArrivalTime != null">, </span>
              <span *ngIf="route[0].MonitoredCall.ExpectedArrivalTime === null"></span>
              <span *ngIf="route[1].MonitoredCall.ExpectedArrivalTime != null">{{route[1].MonitoredCall.ExpectedArrivalTime}}</span>
              <span *ngIf="route[1].MonitoredCall.ExpectedArrivalTime === null"></span> 
              <span *ngIf="route[0].MonitoredCall.ExpectedArrivalTime != null || route[1].MonitoredCall.ExpectedArrivalTime != null" class="minNormal">  min</span>
            </span>
        </div>
        </span>
      </div>
    </div>
    
    <div  *ngIf="noPredictionBubbles">
      <div *ngFor="let noPrediction of noMonitoredVehicleJourney">
        <div class="operatorHeader">{{noPrediction.operatorName}} <span class="minNormal">{{' #' + noPrediction.stopCodeOff}}</span></div>
        <div class="bubble-container">
          <div class="bubbles_second" style="width: 420px;"> {{noPrediction.stopCodeOff}}<span class="offline_nodata">Offline! no information available</span></div>
          <div class="bubbles_last" style="text-align: center;">-- --</div>
        </div>
      </div>
   </div>
</div>

<div class="currentTime">
  {{localTime}}
</div>